import { render, staticRenderFns } from "./PDimensionSearch.vue?vue&type=template&id=09c31ffa"
import script from "./PDimensionSearch.vue?vue&type=script&lang=js"
export * from "./PDimensionSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports